import { createSlice } from "@reduxjs/toolkit";

const accountCategorySlice = createSlice({
  name: "accountCategory",
  initialState: {
    isLoading: false,
    isLogin: false,
    accountCategoryList: [],
    // employeeDropDown: [],
  },
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setAccountCategoryList(state, action) {
      state.accountCategoryList = action.payload;
    },
    // setEmployeeDropDown(state, action) {
    //   state.employeeDropDown = action.payload;
    // },
  },
});

export const { setIsLoading, setAccountCategoryList: setAccountCategoryList } =
  accountCategorySlice.actions;
export default accountCategorySlice.reducer;
